import { Country } from './Country';
import { Disaster } from './Disaster';

export interface RecentSurveyResponse {
  surveySubmissionId?: number;
  lastUpdatedDate?: number;
  organizationName?: string;
  organizationId?: number;
  hqAddress?: {
    value?: {
      country?: Country;
    };
  };
  disaster?: Disaster;
  country?: Country;
}
